enum AUTHSTATES {
  AUTHORIZED = "authorized",
  UNAUTHORIZED = "unauthorized",
}

export default AUTHSTATES;
